export default __webpack_public_path__ + "static/media/Commander's Chestplate of Heaven's Pass.e869b2d2.jpg";